import {tokens} from '@pleo-io/telescope'
import VisuallyHidden from '@reach/visually-hidden'
import React from 'react'
import styled from 'styled-components'

import starIcon from '@/images/icons/star.svg'

const STAR_SIZE = 20

interface Props {
    numberOfStars: number
}

const Stars = ({numberOfStars}: Props) => {
    const wrapperWidth = `calc(${numberOfStars * STAR_SIZE}px + ${numberOfStars - 1} * ${
        tokens.spacing4
    })`

    return (
        <Wrapper style={{width: wrapperWidth}}>
            <VisuallyHidden>{`${numberOfStars} star rating`}</VisuallyHidden>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    height: ${STAR_SIZE}px;
    background-image: url(${starIcon});
    background-repeat: space;
`

export default Stars
